import * as React from "react";
const SafetyAndSecurityIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#safety-and-security_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m43.19 9.973-15-2.95a.812.812 0 0 0-.38 0l-15 2.95a.997.997 0 0 0-.81.98v20.18c0 9.86 7.3 17.85 16 17.85s16-7.99 16-17.85V10.954a.997.997 0 0 0-.81-.98v-.001Zm-8.51 18.3-.7.69-5.62 5.87a.505.505 0 0 1-.72 0l-5.62-5.87-.7-.69a4.334 4.334 0 0 1-.06-6.17 4.23 4.23 0 0 1 2.89-1.13c1.118 0 2.191.438 2.99 1.22l.86.79.86-.79a4.274 4.274 0 0 1 2.99-1.22 4.23 4.23 0 0 1 2.89 1.13 4.334 4.334 0 0 1-.06 6.17Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "safety-and-security_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v56.001H0z"
}))));
export default SafetyAndSecurityIcon;